"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./tabs.css");
var _tabList = _interopRequireDefault(require("./tab-list"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * A `Tabs` allows for separating content into tabbed-sections, restricting visibility to one `TabPanel` based on the active `Tab`. A slider indicates to the user which tab is currently active.
 *
 * The `Tabs` component should be built using a set structure that includes `Tab` components wrapped in a `TabList`, followed by `TabPanel` components wrapped in a `TabPanelList`.
 */
var Tabs = function Tabs(_ref) {
  var activeTab = _ref.activeTab,
    activeTabSliderClassName = _ref.activeTabSliderClassName,
    children = _ref.children,
    inactiveTabClassName = _ref.inactiveTabClassName,
    onTabChange = _ref.onTabChange,
    scrollable = _ref.scrollable,
    shouldFlattenTabListChildren = _ref.shouldFlattenTabListChildren;
  var id = (0, _uniqueId2["default"])('tabs');
  var _useState = (0, _react.useState)(activeTab ? activeTab : 0),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabState = _useState2[0],
    setActiveTabState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!(0, _isNil2["default"])(activeTab) && activeTabState !== activeTab) setActiveTabState(activeTab);
  }, [activeTab]);
  var handleTabChange = function handleTabChange(tab) {
    onTabChange && onTabChange(tab);
    setActiveTabState(tab);
  };
  var childrenWithProps = _react["default"].Children.map(children, function (child) {
    if (!child) return null;
    var isTabList = child.type.displayName === _tabList["default"].displayName;
    var additionalProps = isTabList ? {
      activeTabSliderClassName: activeTabSliderClassName,
      shouldFlattenTabListChildren: shouldFlattenTabListChildren,
      inactiveTabClassName: inactiveTabClassName,
      onTabChange: handleTabChange,
      scrollable: scrollable,
      setActiveTab: setActiveTabState
    } : {};
    return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread({
      activeTab: activeTabState,
      parentId: id
    }, additionalProps));
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, childrenWithProps);
};
Tabs.displayName = 'Tabs';
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A prop to set the active tab index. Use this in tandem with `onTabChange` to have a controlled `Tabs` component.
   */
  activeTab: _propTypes["default"].number,
  /**
   * This class is assigned to the active tab slider that indicates which tab is active. Use this to customize certain styling of the active-tab-indicator, such as the background color.
   */
  activeTabSliderClassName: _propTypes["default"].string,
  /**
   * Children should be passed in with a defined structure.
   *
   * The `Tabs` components should have only a `TabList` and a `TabPanelList`.
   *
   * Within the `TabList` should be n-number of `Tab` components. Within the `TabPanelList` should be n-number of `TabPanel` components.
   */
  children: function children(props, propName, componentName) {
    var error;
    var prop = props[propName];
    _react["default"].Children.forEach(prop, function (child) {
      if (!child) return;
      if (child.type.displayName !== 'TabList' && child.type.displayName !== 'TabPanelList') {
        error = new Error("`".concat(componentName, "` only accepts children of type `TabList` or `TabPanelList`."));
      }
    });
    return error;
  },
  /**
   * This class is assigned to all inactive tabs.
   */
  inactiveTabClassName: _propTypes["default"].string,
  /**
   * An optional callback that receives the index of the active tab, when the active tab changes.
   */
  onTabChange: _propTypes["default"].func,
  /**
   * If true, the tabs are wrapped in a carousel and are fixed-width by default. This allows for tabs to overflow, and provides pager navigation for the user to view more tabs. If true, `carouselProps` should be passed into the `TabList` component, with appropriate Aria messaging.
   */
  scrollable: _propTypes["default"].bool,
  /**
   * If true, Tab children of the TabList element will be flattened into a single array.  This can be useful when loading dynamic tab elements into multiple collections and will prevent animation issues as a result.
   */
  shouldFlattenTabListChildren: _propTypes["default"].bool
} : {};
Tabs.defaultProps = {
  onTabChange: function onTabChange() {},
  scrollable: false,
  shouldFlattenTabListChildren: false
};
var _default = exports["default"] = Tabs;